export const FormatNumber = (
    num?: number | string | null,
    plug: string = '-',
    toFixedValue: number = 2
): string => {
    if (num === undefined || num === null || num === '') return plug;

    const parsed = typeof num === 'string' ? parseFloat(num) : num;

    if (isNaN(parsed)) return plug;

    const formatted = parsed.toFixed(toFixedValue);

    const parts = formatted.split('.');

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return parts.join('.');
};
